import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function MediaQueryLg(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('lg'));
  if(matches) {
    return props.content
  } else {
    return null
  }
}

export default MediaQueryLg;